import React, { useState, useEffect } from 'react';

import { isMobile } from 'react-device-detect';

import { saveAs } from 'file-saver';
import { v4 as uuid } from 'uuid';

import { Row, Col, notification, Divider, Typography, Card } from 'antd';
import { PhoneFilled } from '@ant-design/icons';

import { dataURItoBlob } from '@extensions/utils';

import { exception } from '@extensions/notification';

import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

import { serverFetch } from '@flc/server';

import { IContact } from '@entities/contact';

const dayjs = require('dayjs');
var utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

interface IContactGroup {
    cityName: string;
    contacts: Array<IContact>;
}

const Info = () => {
    const d = useAppDispatch();

    const { Title } = Typography;

    const [api, contextHolder] = notification.useNotification();

    const [headers, setHeaders] = useState<Array<IContactGroup>>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setHeaders([]);

        setLoading(true);

        serverFetch('contacts', { method: 'GET' })
            .then((data) => {
                setHeaders(data);
                setLoading(false);
            })
            .catch((ex) => {
                exception(api, 'Ошибка получения контактов', ex, () => d(userLoaded(undefined)));
                setLoading(false);
            });
    }, []);

    const onDownload = async () => {
        serverFetch(`files/rulesofclaimssubmission`, { method: 'GET' })
            .then((data: any) => {
                const fileBody = `data:${data.contentType};base64,${data.fileContents}`;
                saveAs(dataURItoBlob(fileBody), data.fileDownloadName);
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка загрузки правил выставления претензий', ex, () => d(userLoaded(undefined)));
            });
    };

    const renderContact = (contact: IContact) => {
        return (
            <>
                <div style={{ marginLeft: 5, fontSize: 16 }}>
                    <u style={{ fontWeight: 500 }}>{contact.workingPosition}:</u>
                    <div>{contact.fullName}</div>
                    <div>
                        <PhoneFilled style={{ marginRight: 5 }} />
                        {contact.phone}
                    </div>
                </div>
            </>
        );
    };

    const renderHeader = () => {
        if (headers.length <= 0) return;

        return headers.map((header) => {
            return (
                <Card
                    key={uuid()}
                    title={header.cityName}
                    styles={{
                        root: {
                            marginTop: 20,
                        },
                        header: {
                            fontSize: 18,
                        },
                        body: { fontSize: 14, whiteSpace: 'pre-wrap' },
                    }}
                >
                    {header.contacts.map((c) => (
                        <div key={uuid()}>{renderContact(c)}</div>
                    ))}
                </Card>
            );
        });
    };

    const renderFiles = () => {
        return (
            <>
                <Divider titlePlacement='left' style={{ marginBottom: 0 }}>
                    Файлы
                </Divider>
            </>
        );
    };

    return (
        <Row>
            <Col span={isMobile ? 24 : 10}>
                {renderFiles()}

                {headers.length > 0 && (
                    <>
                        <Divider titlePlacement='left' style={{ marginBottom: 0, marginTop: 40 }}>
                            Контакты
                        </Divider>
                        {renderHeader()}
                    </>
                )}
            </Col>

            {contextHolder}
        </Row>
    );
};

export default Info;
